import { PricingPage } from "apps/oneOnboarding/pricing/Page";
import { criticalMark } from "libs/analytics/criticalMark";

export default criticalMark(PricingPage, "PricingPage");
